import { Text } from "@ui-kitten/components";
import i18n from "plugins/localization";
import React from "react";
import { Pressable, View } from "react-native";

const TopPortion = () => {
  return (
    <View style={{ alignItems: "center", justifyContent: "center" }}>
      <Pressable style={{ marginTop: 15 }}>
        <Text
          style={{ fontSize: 16, marginBottom: 5 }}
          onPress={() => (window.location.href = "/login")}
        >
          {i18n.t("common.alreadyAMember") as string}
        </Text>
      </Pressable>
    </View>
  );
};

export default TopPortion;
